// extracted by mini-css-extract-plugin
export default {"root":"Emoji-module__root"};